// plan-19 S07: commune Q&A → canvas text renderer for exportCard

import type { CommuneResult } from './generate'
import type { ContentRegion } from '../../core/exportCard'
import { wrapText } from '../../core/exportCard'

const COLOR_GREEN_DIM = '#005A00'
const COLOR_KING_GREEN = '#00B400'
const COLOR_TERM_GREEN = '#00D200'

const FONT_FAMILY = '"IBM Plex Mono", monospace'

export function renderCommuneContent(
  result: CommuneResult,
): (ctx: CanvasRenderingContext2D, region: ContentRegion) => void {
  return (ctx, region) => {
    ctx.textAlign = 'left'
    ctx.textBaseline = 'alphabetic'

    const lineH = 42
    const x = region.x
    const maxW = region.w
    let y = region.y + lineH

    // > question: <normalized>
    ctx.font = `18px ${FONT_FAMILY}`
    ctx.fillStyle = COLOR_GREEN_DIM
    y = wrapText(ctx, `> question: ${result.question}`, x, y, maxW, 32)
    y += 16

    // -- commune -- (centered-ish — left-align with em-dashes)
    ctx.fillStyle = COLOR_GREEN_DIM
    ctx.font = `16px ${FONT_FAMILY}`
    ctx.fillText('-- commune --', x, y)
    y += lineH

    // 3 answer lines
    // observation — king-green
    ctx.font = `22px ${FONT_FAMILY}`
    ctx.fillStyle = COLOR_KING_GREEN
    y = wrapText(ctx, result.lines[0], x, y, maxW, lineH)

    // interpretation — king-green
    y = wrapText(ctx, result.lines[1], x, y, maxW, lineH)

    // verdict — term-green
    ctx.fillStyle = COLOR_TERM_GREEN
    y = wrapText(ctx, result.lines[2], x, y, maxW, lineH)

    y += 16

    // -- // end divider
    ctx.font = `16px ${FONT_FAMILY}`
    ctx.fillStyle = COLOR_GREEN_DIM
    ctx.fillText('-- //', x, y)
    y += 32

    // @qHash
    ctx.fillText(`@qHash: ${result.qHash}`, x, y)
  }
}
